import isEmpty from 'lodash/isEmpty';

export const serializeEditorData = (nodes) =>
    Object.keys(nodes).reduce((acc, key) => {
        const { id, styles = {}, meta = {}, descendants, type, childNodes, root } = nodes[key];
        return {
            ...acc,
            [id]: {
                id,
                type,
                props: {
                    styles,
                    meta,
                    ...(!isEmpty(descendants) ? { descendants } : {}),
                },
                childNodes,
                ...(root && { root }),
            },
        };
    }, {});
